import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import {
  FORGET_PASSWORD,
  getUserContext,
  GET_CITATION_ENABLED,
  GET_USER_CONTEXT,
  LOGIN,
  loginComplete,
  logOutComplete,
  LOG_OUT,
  registerDriverComplete,
  REGISTER_DRIVER,
  RESET_PASSWORD,
  setCitationEnabled,
  setUserContext,
  unsetPath,
  UNSET_PATH_SAGA,
  VERIFY_EMAIL,
  setforgetPassword,
  setforgetUserName,
  FORGET_USERNAME,
  setCutationDurationDay,
  GET_CITATION_APPEALS_PREFERENCES,
  KEYCLOAKLOGIN,
  showMissMatchDriverIdModal,
} from "./action";
import { RouteService, resolveCustomerName } from "../../services/route.service";
import history from "../../services/browser.js";
import { callApi, callApiWithNoAuth, Method } from "../../api/Api";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import { setProfileStates } from "../profile/action";

export function* callKeycloakLogin(action) {
  try {
    const store = yield select();
    const userDataaaa = JSON.parse(localStorage.getItem('keycloak'));
    var jwt = userDataaaa.token;
    var tokens = jwt.split(".");
    var userNameSSO = JSON.parse(atob(tokens[1])).preferred_username
    var groupNameSSO = action.payload

    const responseData = {
      access_token: userDataaaa?.token,
      refresh_token: userDataaaa?.refreshToken,
      token_type: userDataaaa?.tokenParsed?.typ,
      session_state: userDataaaa?.tokenParsed?.session_state,
      not_before_policy: 0,
      expires_in: 900,
      refresh_expires_in: 1800,
      scope: "email profile"
    }
    responseData.timestamp = Date.now();
    yield put(loginComplete(responseData));

    const datacheckAccoutID = {
      accountId: userNameSSO,
      userName: userNameSSO,
      permissionGroup: groupNameSSO
    }
    const stateResponceCheckAccountId = yield call(callApi, {
      data: datacheckAccoutID,
       method: Method.POST,
      url: "/eua/check-accountid",
    })

    const stateResponse = yield call(callApi, {
      method: "GET",
      url: `/driversaccount/user-name/${userNameSSO}/${groupNameSSO}`,
    });
    yield put(getUserContext());
    // End code Check Account Id in keycloak
    yield put(setProfileStates(stateResponse?.data));
    /////////////end verify email////////////
    yield put(stopLoading());
    if(stateResponceCheckAccountId && stateResponceCheckAccountId?.status == 200){
      if (stateResponse?.data?.verifyEmail === true) {
        if (stateResponse?.data?.endUserAccountEntity?.person?.addresses.length == 0
          || stateResponse?.data?.endUserAccountEntity?.person?.emailAddresses.length == 0
          || stateResponse?.data?.endUserAccountEntity?.person?.phones.length == 0
          || stateResponse?.data?.endUserAccountEntity?.person?.vehicles.length == 0) {
          yield put(loginComplete(responseData));
          yield put(getUserContext());
          history.push(RouteService.verifyDashboard(store.homeState.customerName));
        } else {
          yield put(loginComplete(responseData));
          yield put(getUserContext());
          history.push(RouteService.dashboard(store.homeState.customerName));
        }
      }
      else {
        yield put(
          showErrorMessage({
            error: { data: { errorMessages: "Please Verify Your Email First" } },
            title: "Unauthorized Login",
          })
        );
      }
    }
  } catch (err) {
    yield put(stopLoading());
    if(err && err?.status == 404 && err?.data?.errorMessages == "Driver ID does not exist."){
      yield put(showMissMatchDriverIdModal())
    }else{
      yield put(showErrorMessage({ error: err, title: "Login Failed" }));
    }
  }
}
export function* watchKeycloakLogin() {
  yield takeLatest(KEYCLOAKLOGIN, callKeycloakLogin);
}


export function* callLogin(action) {
  try {
    yield put(startLoading());

    const response = yield call(callApiWithNoAuth, {
      data: action.payload,
      method: "POST",
      url: `/portal/pages/home-without-session/get-token`,
    });
    var responseData = response.data;
    responseData.timestamp = Date.now();

    const store = yield select();
    // // //////verify email/////////////////
    yield put(loginComplete(responseData));

    const stateResponse = yield call(callApi, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${response.data.access_token || responseData?.access_token
          }`,
        "Content-Type": "application/json",
      },
      url: `/driversaccount/user-name/${action?.payload?.username}/${action.payload.groupName}`,
    });
    yield put(getUserContext());

    yield put(setProfileStates(stateResponse?.data));
    /////////////end verify email////////////
    yield put(stopLoading());
    if (stateResponse?.data?.verifyEmail === true) {
      if (stateResponse?.data?.endUserAccountEntity?.person?.addresses.length == 0
        || stateResponse?.data?.endUserAccountEntity?.person?.emailAddresses.length == 0
        || stateResponse?.data?.endUserAccountEntity?.person?.phones.length == 0
        || stateResponse?.data?.endUserAccountEntity?.person?.vehicles.length == 0) {
        yield put(loginComplete(responseData));
        yield put(getUserContext());
        history.push(RouteService.verifyDashboard(store.homeState.customerName));
      } else {
        yield put(stopLoading());
        yield put(loginComplete(responseData));
        yield put(getUserContext());
        history.push(RouteService.dashboard(store.homeState.customerName));
        yield put(stopLoading());
      }

    }else {
      yield put(
        showErrorMessage({
          error: { data: { errorMessages: "Please Verify Your Email First" } },
          title: "Unauthorized Login",
        })
      );
    }
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Login Failed" }));
  }
}

export function* watchLogin() {
  yield takeLatest(LOGIN, callLogin);
}


export function* callRegister(action) {
  try {
    yield put(startLoading());
    const store = yield select();
    const registerResponse = yield call(callApiWithNoAuth, {
      data: action.payload,
      method: "POST",
      url: `/portal/pages/home-without-session/drivers-create/${store.homeState.customerName}`,
    });
    yield put(registerDriverComplete(registerResponse.data));

    yield put(stopLoading());
    history.push(
      RouteService.registrationSuccess(store.homeState.customerName)
    );
  } catch (err) {
    let error = { data: { errorMessages: err?.data?.errorMessages[0] } };
    yield put(stopLoading());
    yield put(showErrorMessage({ error: error, title: "Registration Failed" }));
  }
}

export function* watchRegister() {
  yield takeLatest(REGISTER_DRIVER, callRegister);
}

export function* callLogOut(action) {
  yield put(startLoading());
  const store = yield select();
  yield put(logOutComplete());
  yield put(stopLoading());

  const customer = resolveCustomerName(
    store.homeState.customerName,
    window.location.pathname
  );

  history.push(
    RouteService.home(customer),
    { reason: action.payload?.reason }
  );
}

export function* watchLogOut() {
  yield takeEvery(LOG_OUT, callLogOut);
}

export function* callUnsetPath() {
  yield put(unsetPath());
}
export function* watchUnsetPath() {
  yield takeEvery(UNSET_PATH_SAGA, callUnsetPath);
}

export function* callForgetPassword(action) {
  try {
    yield put(startLoading());
    const store = yield select();
    const registerResponsedata = yield call(callApiWithNoAuth, {
      data: action.payload,
      method: "POST",
      url: `/portal/pages/home-without-session/send-link`,
    });
    yield put (setforgetPassword(registerResponsedata.data))
    yield put(stopLoading())
    history.push(
      RouteService.resetPasswordStatus(store.homeState.customerName)
    );
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Forget Password Failed" })
    );
  }
}
export function* watchForgetPassword() {
  yield takeLatest(FORGET_PASSWORD, callForgetPassword);
}
// forgot user name saga start 
export function* callForgetUserName(action) {
  let datass = {
    groupName:action.payload?.groupName,
    accountId:action.payload?.userName
  }
  try {
    yield put(startLoading());
    const store = yield select();
   
    const registerResponsedata = yield call(callApiWithNoAuth, {
      data: datass,
      method: "POST",
      url: `/portal/pages/home-without-session/send-username-link`,
    });
    yield put (setforgetUserName(registerResponsedata.data))
    yield put(stopLoading())
    history.push(
      RouteService.resetUsernameStatus(store.homeState.customerName)
    );
  } catch (err) {
    yield put(stopLoading());
    yield put(
      showErrorMessage({ error: err, title: "Username not found for this ID" })
    );
  }
}
export function* watchForgetuserName() {
  yield takeLatest(FORGET_USERNAME, callForgetUserName);
}
// forgot username saga end 
export function* callResetPassword(action) {
  try {
    yield put(startLoading());

    yield call(callApiWithNoAuth, {
      data: action.payload.data,
      method: "POST",
      url: `/portal/pages/home-without-session/update-driver-password/${action.payload.customerName}`,
    });
    yield put(stopLoading());
    history.push(
      RouteService.resetPasswordSuccess(action.payload.customerName)
    );
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Reset Password Failed" }));
  }
}
export function* watchResetPassword() {
  yield takeLatest(RESET_PASSWORD, callResetPassword);
}

export function* callGetUserContext() {
  const data = window.location.href
let urls = String(data)
let getGroupname = (url)=>{
let f = url.split("/")
let dats
for(let i=2;i<f.length;i++){
if(f[i]=="driverportal"){
dats = f[i+1]
}
}
return dats
}
  try {
    const res = yield call(callApi, {
      url: `/user-context/driver-portal/${getGroupname(urls)}`,
      method: Method.GET,
    });
    const { data } = res;

    // Ensure userGroup is always present
    if (!data.user.userGroup) {
      const userGroup = getGroupname(urls);
      data.user = { ...data.user, userGroup }; // Add userGroup to the user object if missing
    }

    yield put(setUserContext(data));
  } catch (err) {
    yield put(showErrorMessage({ error: err, title: "User Details Error" }));
  }
}
export function* watchGetUserContext() {
  yield takeLatest(GET_USER_CONTEXT, callGetUserContext);
}

export function* callVerifyEmail(action) {
  try {
    yield put(startLoading());
    const store = yield select();

    let formdata = {
      username: action.payload,
      verifyEmail: true,
    };
    const res = yield call(callApiWithNoAuth, {
      data: formdata,
      method: "PUT",
      url: `/portal/pages/home-without-session/email-verified/${store.homeState.customerName}`,
    });
    let resdata = res.data;
    yield put(stopLoading());
    history.push(RouteService.login(store.homeState.customerName));
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Verify Email Error" }));
  }
}
export function* watchGetVerifyEmail() {
  yield takeLatest(VERIFY_EMAIL, callVerifyEmail);
}

export function* callGetCitationEnabled(action) {
  try {

    const responseData = yield call(callApiWithNoAuth, {
      url: `/portal/pages/home-without-session/user-context/check-citation-status/${action?.payload}`,
      method: Method.GET,
    });
    yield put(setCitationEnabled(responseData?.data));
  } catch (err) {
    yield put(
      showErrorMessage({ error: err, title: "citation enabled Error" })
    );
  }
}
export function* watchGetCitationEnabled() {
  yield takeLatest(GET_CITATION_ENABLED, callGetCitationEnabled);
}

// Appeal Duration Days
export function* callGetCitationAppealsPreferences(action) {
  try {
    const response = yield call(callApiWithNoAuth, {
      url: `/portal/pages/home-without-session/citation-appeals-prefs/${action.payload}`,
      method: Method.GET,
    });
    const {data} = response

    yield put(setCutationDurationDay(data));

  } catch (err) {
    yield put(showErrorMessage({ error: err, title: "Citation Appeal Days" }));
  }
}

export function* watchGetCitationAppealsPreferences() {
  yield takeLatest( GET_CITATION_APPEALS_PREFERENCES, callGetCitationAppealsPreferences);
}
